/*
    © 2021 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Cart count badges - Animate every 5 sec
setInterval(() => {
    document.querySelectorAll('.cart-count-badge').forEach((badge) => {
        badge.classList.add(badge.dataset.animateClass)

        setTimeout(() => {
            badge.classList.remove(badge.dataset.animateClass)
        }, 2000)
    })
}, 5000)

// Megamenu - tabs open on hover
document.querySelectorAll('.navbar [data-bs-toggle="pill"]').forEach((tab) => {
    tab.addEventListener('mouseenter', () => {
        document.querySelectorAll('.tab-pane.fade.active.show').forEach((tabPane) => {
            tabPane.classList.remove('active')
            tabPane.classList.remove('show')
        })
        const bsTab = bootstrap.Tab.getOrCreateInstance(tab)
        bsTab.show()
    })
    tab.addEventListener('click', () => {
        window.location.href = tab.getAttribute('href')
    })
})

// Handle Plus/Minus in quantity steppers
window.qtyDecrease = (btn) => {
    const input = btn.closest('.quantity-wrapper').querySelector('input')
    const inputValue = Number(input.value)

    if (inputValue > 1) {
        input.value = inputValue - 1
    }
}
window.qtyIncrease = (btn) => {
    const input = btn.closest('.quantity-wrapper').querySelector('input')
    const inputValue = Number(input.value)

    input.value = inputValue + 1
}